import { cilAddressBook, cilBank, cilCash, cilChartLine, cilCreditCard, cilDescription, cilSettings } from "@coreui/icons"
const VendorsIco = () => {
  return <svg width="800px" class="nav-icon" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.5 21.5V18.5C9.5 17.5654 9.5 17.0981 9.70096 16.75C9.83261 16.522 10.022 16.3326 10.25 16.201C10.5981 16 11.0654 16 12 16C12.9346 16 13.4019 16 13.75 16.201C13.978 16.3326 14.1674 16.522 14.299 16.75C14.5 17.0981 14.5 17.5654 14.5 18.5V21.5" stroke="var(--ci-primary-color, currentColor)" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M21 22H9M3 22H5.5" stroke="var(--ci-primary-color, currentColor)" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M19 22V15" stroke="var(--ci-primary-color, currentColor)" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M5 22V15" stroke="var(--ci-primary-color, currentColor)" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M11.9999 2H7.47214C6.26932 2 5.66791 2 5.18461 2.2987C4.7013 2.5974 4.43234 3.13531 3.89443 4.21114L2.49081 7.75929C2.16652 8.57905 1.88279 9.54525 2.42867 10.2375C2.79489 10.7019 3.36257 11 3.99991 11C5.10448 11 5.99991 10.1046 5.99991 9C5.99991 10.1046 6.89534 11 7.99991 11C9.10448 11 9.99991 10.1046 9.99991 9C9.99991 10.1046 10.8953 11 11.9999 11C13.1045 11 13.9999 10.1046 13.9999 9C13.9999 10.1046 14.8953 11 15.9999 11C17.1045 11 17.9999 10.1046 17.9999 9C17.9999 10.1046 18.8953 11 19.9999 11C20.6373 11 21.205 10.7019 21.5712 10.2375C22.1171 9.54525 21.8334 8.57905 21.5091 7.75929L20.1055 4.21114C19.5676 3.13531 19.2986 2.5974 18.8153 2.2987C18.332 2 17.7306 2 16.5278 2H16" stroke="var(--ci-primary-color, currentColor)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
}
const ContractsIco=()=>{
  return<svg viewBox="0 0 1024 1024" class="nav-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="var(--ci-primary-color, currentColor)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M182.52 146.2h585.14v256h73.15V73.06H109.38v877.71h256v-73.14H182.52z" fill="var(--ci-primary-color, currentColor)"></path><path d="M255.67 219.34h438.86v73.14H255.67zM255.67 365.63h365.71v73.14H255.67zM255.67 511.91H475.1v73.14H255.67zM775.22 458.24L439.04 794.42l-0.52 154.64 155.68 0.52L930.38 613.4 775.22 458.24z m51.72 155.16l-25.43 25.43-51.73-51.72 25.44-25.44 51.72 51.73z m-77.14 77.15L620.58 819.77l-51.72-51.72 129.22-129.22 51.72 51.72zM511.91 876.16l0.17-51.34 5.06-5.06 51.72 51.72-4.85 4.85-52.1-0.17z" fill="var(--ci-primary-color, currentColor)"></path></g></svg>
}

const CustomIco=()=>{
  return<svg width="800px" class="nav-icon" height="800px" viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" aria-labelledby="stickerIconTitle" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none" color="var(--ci-primary-color, currentColor)"> <title id="stickerIconTitle">Sticker</title> <path d="M21,3 L21,11 C21,16.5228475 16.5228475,21 11,21 L3,21 L3,3 L21,3 Z"/> <path d="M9,21 C11.6666667,21 13,19.6666667 13,17 C13,17 13,15.6666667 13,13 L17,13 C19.6666667,13 21,11.6666667 21,9"/> </svg>
}
const InventoryIco = () => {
  return <svg width="800px" class="nav-icon" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.55281 1.60553C7.10941 1.32725 7.77344 1 9 1C10.2265 1 10.8906 1.32722 11.4472 1.6055L11.4631 1.61347C11.8987 1.83131 12.2359 1.99991 13 1.99993C14.2371 1.99998 14.9698 1.53871 15.2141 1.35512C15.5944 1.06932 16.0437 1.09342 16.3539 1.2369C16.6681 1.38223 17 1.72899 17 2.24148L17 13H20C21.6562 13 23 14.3415 23 15.999V19C23 19.925 22.7659 20.6852 22.3633 21.2891C21.9649 21.8867 21.4408 22.2726 20.9472 22.5194C20.4575 22.7643 19.9799 22.8817 19.6331 22.9395C19.4249 22.9742 19.2116 23.0004 19 23H5C4.07502 23 3.3148 22.7659 2.71092 22.3633C2.11331 21.9649 1.72739 21.4408 1.48057 20.9472C1.23572 20.4575 1.11827 19.9799 1.06048 19.6332C1.03119 19.4574 1.01616 19.3088 1.0084 19.2002C1.00194 19.1097 1.00003 19.0561 1 19V2.24146C1 1.72899 1.33184 1.38223 1.64606 1.2369C1.95628 1.09341 2.40561 1.06931 2.78589 1.35509C3.03019 1.53868 3.76289 1.99993 5 1.99993C5.76415 1.99993 6.10128 1.83134 6.53688 1.6135L6.55281 1.60553ZM3.00332 19L3 3.68371C3.54018 3.86577 4.20732 3.99993 5 3.99993C6.22656 3.99993 6.89059 3.67269 7.44719 3.39441L7.46312 3.38644C7.89872 3.1686 8.23585 3 9 3C9.76417 3 10.1013 3.16859 10.5369 3.38643L10.5528 3.39439C11.1094 3.67266 11.7734 3.9999 13 3.99993C13.7927 3.99996 14.4598 3.86581 15 3.68373V19C15 19.783 15.1678 20.448 15.4635 21H5C4.42498 21 4.0602 20.8591 3.82033 20.6992C3.57419 20.5351 3.39761 20.3092 3.26943 20.0528C3.13928 19.7925 3.06923 19.5201 3.03327 19.3044C3.01637 19.2029 3.00612 19.1024 3.00332 19ZM19.3044 20.9667C19.5201 20.9308 19.7925 20.8607 20.0528 20.7306C20.3092 20.6024 20.5351 20.4258 20.6992 20.1797C20.8591 19.9398 21 19.575 21 19V15.999C21 15.4474 20.5529 15 20 15H17L17 19C17 19.575 17.1409 19.9398 17.3008 20.1797C17.4649 20.4258 17.6908 20.6024 17.9472 20.7306C18.2075 20.8607 18.4799 20.9308 18.6957 20.9667C18.8012 20.9843 18.8869 20.9927 18.9423 20.9967C19.0629 21.0053 19.1857 20.9865 19.3044 20.9667Z" fill="var(--ci-primary-color, currentColor)" />
    <path d="M5 8C5 7.44772 5.44772 7 6 7H12C12.5523 7 13 7.44772 13 8C13 8.55229 12.5523 9 12 9H6C5.44772 9 5 8.55229 5 8Z" fill="var(--ci-primary-color, currentColor)" />
    <path d="M5 12C5 11.4477 5.44772 11 6 11H12C12.5523 11 13 11.4477 13 12C13 12.5523 12.5523 13 12 13H6C5.44772 13 5 12.5523 5 12Z" fill="var(--ci-primary-color, currentColor)" />
    <path d="M5 16C5 15.4477 5.44772 15 6 15H12C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H6C5.44772 17 5 16.5523 5 16Z" fill="var(--ci-primary-color, currentColor)" />
  </svg>
};
const ReportsIco = () => {
  return <svg id="Capa_1" class="nav-icon" viewBox="0 0 60 60">
   <path d="M56.5,49L56.5,49V1c0-0.6-0.4-1-1-1h-45c-0.6,0-1,0.4-1,1v14h2V2h43v46h-9c-0.6,0-1,0.4-1,1v9h-33V43h-2v16 c0,0.6,0.4,1,1,1h35c0.3,0,0.5-0.1,0.7-0.3l10-10c0.1-0.1,0.1-0.2,0.2-0.3v-0.1C56.5,49.2,56.5,49.1,56.5,49z M46.5,50h6.6 l-3.3,3.3l-3.3,3.3L46.5,50L46.5,50z"/>
   <path d="M16.5,38h6h4v-2h-3V17c0-0.6-0.4-1-1-1h-6c-0.6,0-1,0.4-1,1v6h-5c-0.6,0-1,0.4-1,1v4h-5c-0.6,0-1,0.4-1,1v8 c0,0.6,0.4,1,1,1h6H16.5z M17.5,18h4v18h-4V24V18z M11.5,25h4v11h-4v-7V25z M5.5,30h4v6h-4V30z"/>
   <path d="M50.5,24V7c0-0.6-0.4-1-1-1h-21c-0.6,0-1,0.4-1,1v17c0,0.6,0.4,1,1,1h21C50.1,25,50.5,24.6,50.5,24z M48.5,12h-12V8h12V12 z M34.5,8v4h-5c0-1.6,0-4,0-4H34.5z M29.5,14h5v9h-5C29.5,23,29.5,18.3,29.5,14z M36.5,23v-9h12v9H36.5z"/>
   <rect x="28.5" y="28" width="21" height="2"/>
   <rect x="28.5" y="33" width="21" height="2"/>
   <rect x="28.5" y="38" width="21" height="2"/>
   <rect x="14.5" y="6" width="6" height="2"/>
   <rect x="14.5" y="11" width="9" height="2"/>
   <rect x="14.5" y="43" width="7" height="2"/>
   <rect x="24.5" y="43" width="7" height="2"/>
   <rect x="34.5" y="43" width="7" height="2"/>
   <rect x="14.5" y="48" width="7" height="2"/>
   <rect x="24.5" y="48" width="7" height="2"/>
   <rect x="34.5" y="48" width="7" height="2"/>
   <rect x="14.5" y="53" width="7" height="2"/>
   <rect x="24.5" y="53" width="7" height="2"/>
   <rect x="34.5" y="53" width="7" height="2"/>
</svg>
};

export default [
  {
    component: 'CNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
    userrole: ["Warehouse", "Finance",]
  },
  {
    component: 'CNavItem',
    name: 'Finance Dashboard',
    to: '/financial-dashboard',
    icon: cilBank,
    userrole: ["Warehouse", "Finance", "Admin"]
  },


  // Order Processing
  {
    component: 'CNavTitle',
    name: 'Orders',
    userrole: ["Warehouse"]
  },
  {
    component: 'CNavItem',
    countBadge: true,
    name: 'All Orders',
    to: '/order-processing/all-orders',
    icon: 'cil-apps-settings',
    userrole: ["Warehouse"]
  },


  // Manage
  {
    component: 'CNavTitle',
    name: 'MANAGE',
    userrole: ["Warehouse"]
  },
  {
    component: 'CNavItem',
    name: 'Warehouse',
    to: '/manage/warehouse',
    icon: 'cil-building',
    userrole: ["Warehouse"]
  },
  {
    component: 'CNavItem',
    name: 'Error Logs',
    to: '/manage/error-logs',
    icon: 'cilXCircle',
    userrole: ["Warehouse"]
  },
  {
    component: 'CNavItem',
    name: 'Zone',
    to: '/manage/zone',
    icon: 'cil-door',
    userrole: ["Warehouse"]
  },
  {
    component: 'CNavItem',
    name: 'Aisle, Rack & Shelf',
    to: '/manage/aisle-rack-shelf',
    icon: 'cil-clear-all',
    userrole: ["Warehouse"]
  },
  {
    component: 'CNavItem',
    name: 'Sales Register',
    to: '/manage/sales-register',
    icon: cilChartLine,
    userrole: ["Finance"]
  },
  {
    component: 'CNavItem',
    name: 'Expense Register',
    to: '/manage/expense-register',
    icon: cilCreditCard,
    userrole: ["Finance"]
  },
  {
    component: 'CNavItem',
    name: 'Finance Register',
    to: '/manage/finance-register',
    icon: cilCash,
    userrole: ["Finance"]
  },
  {
    component: 'CNavItem',
    name: 'Trolley & Bin',
    to: '/manage/trolley-bin',
    icon: 'cil-inbox',
    userrole: ["Warehouse"]
  },
  {
    component: 'CNavItem',
    name: 'Users',
    to: '/manage/users',
    icon: 'cil-user',
    userrole: ["Warehouse"]
  },
  {
    component: 'CNavItem',
    name: 'Barcodes',
    to: '/manage/barcodes',
    icon: 'cil-barcode',
    userrole: ["Warehouse"]
  },

  {
    component: 'CNavItem',
    name: 'Vendor Invoices',
    to: '/manage/billing',
    icon: <InventoryIco />,
    iconCore: true,
    userrole: ["Warehouse",'Finance']
  },
  {
    component: 'CNavItem',
    name: 'Custom Invoices',
    to: '/manage/custom-invoices',
    icon: <CustomIco/>,
    iconCore: true,
    userrole: ["Warehouse",'Finance']
  },
  {
    component: 'CNavItem',
    name: 'Credit Note',
    to: '/manage/credit-note',
    icon: cilCreditCard,
    userrole: ["Finance"]
  },
  {
    component: 'CNavItem',
    name: 'Bills & Reports',
    to: '/manage/bills-and-reports',
    icon: cilDescription,
    userrole: ["Warehouse","Finance", "Admin"]
  },
  {
    component: 'CNavItem',
    name: 'Vendors',
    to: '/manage/vendors',
    iconCore: true,
    icon: <VendorsIco />,
    userrole: ["Warehouse"]
  },
  {
    component: 'CNavItem',
    name: 'Quotations',
    to: '/manage/quotations',
    icon: 'cil-money',
    userrole: ["Warehouse"]
  },
  {
    component: 'CNavItem',
    name: 'Contracts',
    to: '/manage/contracts',
    iconCore: true,
    icon: <ContractsIco />,
    userrole: ["Warehouse"]
  },
  {
    component: 'CNavItem',
    name: 'Reports',
    to: '/manage/reports',
    iconCore: true,
    icon: <ReportsIco />,
    userrole: ["Warehouse", "Finance"]
  },
  {
    component: 'CNavItem',
    name: 'Settings',
    to: '/manage/settings', 
    icon: cilSettings,
    userrole: ["Finance"]
  },
  // Reports

  // {
  //   component: 'CNavTitle',
  //   name: 'REPORTS',
  //   userrole: ["Warehouse"]
  // },
  // {
  //   component: 'CNavItem',
  //   name: 'Stats',
  //   to: '/reports/stats',
  //   icon: 'cil-graph',
  //   userrole: ["Warehouse"]
  // },
  {
    component: 'CNavTitle',
    name: 'Setting',
    userrole: ["Warehouse"]
  },
  {
    component: 'CNavItem',
    name: 'Change Password',
    to: '/change-password',
    icon: 'cil-lock-locked',
    userrole: ["Warehouse"]
  },
]
